import {
  AccreditationEligibilityCriteriaEnumType,
  InvestmentEntityTypeEnumType,
} from '__generated__/graphql';

const IndividualCriteria = [
  {
    value: AccreditationEligibilityCriteriaEnumType.AnnualIncome,
    label: 'Annual Income',
    helperText: 'Annual income of at least INR 2 Crores',
  },
  {
    value: AccreditationEligibilityCriteriaEnumType.NetWorth,
    label: 'Net Worth',
    helperText: 'Net worth of at least INR 7.5 Crores',
  },
  {
    value: AccreditationEligibilityCriteriaEnumType.Combined,
    label: 'Hybrid',
    helperText: 'Annual income of at least INR 1 Crore and net worth of at least INR 5 Crores',
  },
  {
    value: AccreditationEligibilityCriteriaEnumType.JointApplicant,
    label: 'Joint Application',
    helperText:
      'Combined with spouse, an Annual Income of at least INR 2 cr or Net Worth of at least INR 7.5 cr',
  },
];

const BodyCorporateAndTrustCriteria = [
  {
    value: AccreditationEligibilityCriteriaEnumType.NetWorth,
    label: 'Net Worth',
    helperText: 'Net worth of at least INR 50 Crores',
  },
];

const LLPCriteria = [
  {
    value: AccreditationEligibilityCriteriaEnumType.AnnualIncome,
    label: 'Annual Income',
    helperText: 'Annual income of at least INR 2 Crores',
  },
  {
    value: AccreditationEligibilityCriteriaEnumType.NetWorth,
    label: 'Net Worth',
    helperText: 'Net worth of at least INR 7.5 Crores',
  },
  {
    value: AccreditationEligibilityCriteriaEnumType.Combined,
    label: 'Hybrid',
    helperText: 'Annual income of at least INR 1 Crore and net worth of at least INR 5 Crores',
  },
];

const getEligibilityOptions = (investmentEntityType: InvestmentEntityTypeEnumType) => {
  switch (investmentEntityType) {
    case InvestmentEntityTypeEnumType.Individual:
      return IndividualCriteria;
    case InvestmentEntityTypeEnumType.PrivateLimited:
      return BodyCorporateAndTrustCriteria;
    case InvestmentEntityTypeEnumType.PublicLimited:
      return BodyCorporateAndTrustCriteria;
    case InvestmentEntityTypeEnumType.LimitedLiabilityPartnership:
      return LLPCriteria;
    case InvestmentEntityTypeEnumType.Trust:
      return BodyCorporateAndTrustCriteria;
    case InvestmentEntityTypeEnumType.Huf:
      return LLPCriteria;
    default:
      return IndividualCriteria;
  }
};

export { IndividualCriteria, BodyCorporateAndTrustCriteria, LLPCriteria, getEligibilityOptions };
